/** Browser-safe mirror of the font registry (the node config package uses fs). */
export const FONT_REGISTRY = [
  { displayName: 'Inter', family: 'Inter', weights: [300, 400, 500, 600, 700, 800] },
  { displayName: 'Montserrat', family: 'Montserrat', weights: [800, 900] },
  { displayName: 'Poppins', family: 'Poppins', weights: [800, 900] },
  { displayName: 'Fraunces', family: 'Fraunces', weights: [600] },
  { displayName: 'Noto Sans Devanagari', family: 'NotoSansDevanagari', weights: [700] },
  { displayName: 'Baloo 2', family: 'Baloo2', weights: [700, 800] },
  { displayName: 'Fredoka', family: 'Fredoka', weights: [600, 700] },
  { displayName: 'Luckiest Guy', family: 'LuckiestGuy', weights: [400] },
  { displayName: 'Chewy', family: 'Chewy', weights: [400] },
  { displayName: 'Nunito', family: 'Nunito', weights: [800, 900] },
  { displayName: 'Anton', family: 'Anton', weights: [400] },
  { displayName: 'Caveat', family: 'Caveat', weights: [400, 500, 600, 700] },
  { displayName: 'Playfair Display', family: 'PlayfairDisplay', weights: [500] },
  { displayName: 'Playfair Italic', family: 'PlayfairItalic', weights: [500] },
  { displayName: 'Yellowtail', family: 'Yellowtail', weights: [400] },
];

/** Match CSS font-weight fallback ordering for the bundled static faces. */
export function availableFontWeight(family: string, requested: number): number {
  const weights = FONT_REGISTRY.find((font) => font.family === family)?.weights;
  if (!weights) return requested;
  const ascending = [...weights].sort((a, b) => a - b);
  if (requested >= 400 && requested <= 500) {
    return ascending.find((w) => w >= requested && w <= 500)
      ?? [...ascending].reverse().find((w) => w < requested)
      ?? ascending.find((w) => w > 500)!;
  }
  if (requested < 400) {
    return [...ascending].reverse().find((w) => w <= requested) ?? ascending[0]!;
  }
  return ascending.find((w) => w >= requested) ?? ascending[ascending.length - 1]!;
}
